/**
 * Diese Komponente bindet dann das jeweilige Modul ein, lädt die Seiten und übergibt den User, sowie die verfügbaren Socialmediakanäle und die jeweiligen Pfade und Token.
 */

import 'regenerator-runtime/runtime'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { Theme } from '@mui/material'

import { SocialNetworkLicensePermissions } from '@professocial/professocialTypes/types/commonTypes'

import { getLicensePermissions, getTheme, getUser } from '../../../../store/common/common.selectors'
import { getFacebookPage, getInstagramPage, getLinkedInPage } from '../../../../store/dashboard/dashboard.selector'

import { UserSettings } from '@professocialApi/professocial-core-frontend-api'
import { FacebookPage, InstagramPage, LinkedInPage } from '@3m5/sm_publish-frontend-api'

import ImportProfessocialPosting from '../../../../shared/components/ImportComponents/ImportProfessocialPosting'
import { PostingConfiguration } from '@professocial/professocialTypes/types'
import { PostingScreen } from '@professocial/professocialPosting/src/shared/types/types'

const UserDashboardPosting: React.FC = () => {
  const user: UserSettings| undefined = useSelector(getUser)
  const theme: Theme = useSelector(getTheme)
  const licensePermissions: SocialNetworkLicensePermissions = useSelector(getLicensePermissions)

  const storedFacebookPage: FacebookPage | undefined = useSelector(getFacebookPage)
  const storedInstagramPage: InstagramPage | undefined = useSelector(getInstagramPage)
  const storedLinkedInPage: LinkedInPage | undefined = useSelector(getLinkedInPage)

  const [config, setConfig] = useState<PostingConfiguration | undefined>()

  useEffect(() => {
    setConfig({
      networkPage: {
        facebookPage: storedFacebookPage,
        instagramPage: storedInstagramPage,
        linkedInPage: storedLinkedInPage
      },
      user,
      theme,
      licensePermissions: licensePermissions,
      generalPostingOptions: {
        allowLinkParsing: true,
        allowTemplateEdit: false,
        showAsPopUp: false,
        showPreview: true,
        useMediaGallery: true,
        allowLinkIndividualisation: false,
        allowIndividualHashtags: false,
        allowTags: false,
        allowImageUpload: true,
        allowVideoUpload: true,
        templateSelection: true,
      },
    })
  }, [storedFacebookPage, storedInstagramPage])

  return (
    <>
      {config && <ImportProfessocialPosting postingConfiguration={config} postingScreen={PostingScreen.MAIN} />}
    </>
  )
}
export default UserDashboardPosting
